import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import './LegalPage.css';

const LegalPage = () => {
  const { type } = useParams();
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);

  const legalContent = {
    'terms-of-service': {
      title: 'Terms of Service',
      file: 'TERMS_OF_SERVICE.md'
    },
    'privacy-policy': {
      title: 'Privacy Policy', 
      file: 'PRIVACY_POLICY.md'
    },
    'user-agreement': {
      title: 'User Agreement',
      file: 'USER_AGREEMENT.md'
    }
  };

  const currentDoc = legalContent[type];

  useEffect(() => {
    if (currentDoc) {
      fetch(`/${currentDoc.file}`)
        .then(response => response.text())
        .then(text => {
          // Convert markdown to HTML (basic conversion)
          const htmlContent = text
            .replace(/^# (.*$)/gim, '<h1>$1</h1>')
            .replace(/^## (.*$)/gim, '<h2>$1</h2>')
            .replace(/^### (.*$)/gim, '<h3>$1</h3>')
            .replace(/^#### (.*$)/gim, '<h4>$1</h4>')
            .replace(/\*\*(.*)\*\*/gim, '<strong>$1</strong>')
            .replace(/\*(.*)\*/gim, '<em>$1</em>')
            .replace(/^- (.*$)/gim, '<li>$1</li>')
            .replace(/(<li>.*<\/li>)/s, '<ul>$1</ul>')
            .replace(/\n\n/gim, '</p><p>')
            .replace(/^(?!<[h|u|l])/gim, '<p>')
            .replace(/(?![h|u|l]>)$/gim, '</p>');
          
          setContent(htmlContent);
          setLoading(false);
        })
        .catch(error => {
          console.error('Error loading legal document:', error);
          setContent('<p>Error loading document. Please try again later.</p>');
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, [currentDoc]);

  if (loading) {
    return (
      <div className="legal-page">
        <div className="container">
          <div className="legal-header">
            <h1>Loading...</h1>
          </div>
        </div>
      </div>
    );
  }

  if (!currentDoc) {
    return (
      <div className="legal-page">
        <div className="container">
          <div className="legal-header">
            <h1>Legal Documents</h1>
            <p>Document not found.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="legal-page">
      <div className="container">
        <div className="legal-header">
          <h1>{currentDoc.title}</h1>
          <p className="last-updated">Last Updated: January 15, 2025</p>
        </div>
        
        <div className="legal-content">
          <div className="legal-navigation">
            <h3>Quick Navigation</h3>
            <ul>
              <li><a href="#introduction">Introduction</a></li>
              <li><a href="#user-responsibilities">User Responsibilities</a></li>
              <li><a href="#trading-process">Trading Process</a></li>
              <li><a href="#financial-terms">Financial Terms</a></li>
              <li><a href="#safety-guidelines">Safety Guidelines</a></li>
              <li><a href="#dispute-resolution">Dispute Resolution</a></li>
              <li><a href="#contact-information">Contact Information</a></li>
            </ul>
          </div>
          
          <div className="legal-text">
            <div dangerouslySetInnerHTML={{ __html: content }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LegalPage;
